"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomError = void 0;
const errorMessages_1 = require("./errorMessages.js");
class CustomError {
    constructor(triggerName) {
        this.triggerName = triggerName;
        this.triggerName = triggerName;
    }
    createError(message) {
        return new Error(message);
    }
    getErrorMessage(key) {
        return `${this.triggerName} ${errorMessages_1.errorMessages[key]}`;
    }
    missingRequiredProps() {
        throw this.createError(this.getErrorMessage(errorMessages_1.ErrorMessageKeys.REQUIRED_PROPS_MISSING));
    }
}
exports.CustomError = CustomError;
